fragment media on AssetInterface {
    id
    url
    kind
    mimeType
    width
    height
    ... on media_Asset {
        alt
        title
        hasFocalPoint
        focalPoint
    }
}